module.exports = __webpack_public_path__ + "img/assessments-empty.f581bc2b.svg";